document.addEventListener('DOMContentLoaded', function () {
  // 全チェックボックスとセレクトボックスの要素を取得
  const checkboxes = document.querySelectorAll('.c_map__filter-item-label input[type="checkbox"]');
  const selectElement = document.querySelector('.c_map__filter-item-select[name="prefecture"]');
  const resultContainer = document.querySelector('.c_map__result-container'); // 結果を表示する親要素を取得
  
  const remarkElement = document.createElement('p'); // メッセージ要素を作成
  remarkElement.className = 'c_map__remark';
  remarkElement.textContent = '条件に一致する設置場所はございません。';
  resultContainer.appendChild(remarkElement);
  remarkElement.style.display = 'none'; // 初期状態では非表示

  // イベントリスナーをチェックボックスとセレクトボックスに追加
  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', updateDisplay);
  });
  selectElement.addEventListener('change', updateDisplay);

  // 表示を更新する関数
  function updateDisplay() {
    const selectedPrefecture = selectElement.value; // 選択されている都道府県
    const checkedFacilities = Array.from(checkboxes)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.id);

    // すべての結果要素を一旦非表示に設定
    const resultItems = document.querySelectorAll('.c_map__result-item');
    resultItems.forEach(function(result) {
      result.style.display = 'none';
    });

    // 選択されているチェックボックスと都道府県に基づいて要素を表示
    checkedFacilities.forEach(function(facility) {
      let selector = '.c_map__result-item[data-facility="' + facility + '"]';
      if (selectedPrefecture !== 'all-prefecture') {
        selector += '[data-prefecture="' + selectedPrefecture + '"]';
      }
      document.querySelectorAll(selector).forEach(function(result) {
        result.style.display = 'grid';
      });
    });

    // 非表示の結果要素の数を数える
    const hiddenCount = Array.from(resultItems).filter(item => item.style.display === 'none').length;

    // すべての結果要素が非表示の場合、メッセージを表示
    if (hiddenCount === resultItems.length) {
      remarkElement.style.display = 'block';
    } else {
      remarkElement.style.display = 'none';
    }
  }

  const allSelectButton = document.getElementById('js-all-btn');

  // ボタンのクリックイベントにリスナーを追加
  allSelectButton.addEventListener('click', function() {
    // すべてのチェックボックスにチェックを入れる
    checkboxes.forEach(function(checkbox) {
      checkbox.checked = true;
    });

    // セレクトボックスを「すべての都道府県」に設定
    selectElement.value = 'all-prefecture';

    // すべての結果要素を表示
    document.querySelectorAll('.c_map__result-item').forEach(function(result) {
      result.style.display = 'grid';
    });

    // メッセージを非表示に設定
    remarkElement.style.display = 'none';
  });

  // MutationObserverを使用してDOMの変化を監視
  const observer = new MutationObserver(updateDisplay);
  observer.observe(resultContainer, { childList: true, subtree: true });
});
